import { readDealerAdminSession } from '../../pages/Admin/dealerAdminSession';
import { readSupportedTenantSession } from '../../pages/Admin/supportedTenantsSession';

/** Member, dealer, and support caches stay separate even for the same tenant id. */
export function actionCacheScope() {
  const support = readSupportedTenantSession();
  if (support?.tenantId) {
    return `support:${support.tenantId}:${support.accessLevel}`;
  }
  const dealer = readDealerAdminSession();
  if (dealer?.tenantId) {
    return `dealer:${dealer.dealerId}:${dealer.tenantId}`;
  }
  return 'member';
}

export function actionCacheKey(kind, tenantId) {
  return `${actionCacheScope()}::${String(tenantId || '')}::${kind}`;
}

/** A response from an older tenant switch must not be written into the new view. */
export function takeLatestTenantRows(requestGeneration, currentGeneration, rows) {
  if (requestGeneration !== currentGeneration) return null;
  return Array.isArray(rows) ? rows : [];
}
